import { defineMessages } from 'react-intl';

export default defineMessages({
  MyguaranteesBlocTitle: {
    id: 'auto_details_page.my_contracts_bloc.my_guarantees_bloc_title',
  },
});
